import { Injectable, inject } from '@angular/core';
import {
  UserServiceCreateRequest,
  UserServiceCreateResponse,
  UserServiceCreateResponseSchema,
  UserServiceGetResponseSchema,
  UserServiceListRequest,
  UserServiceUpdateRequest,
  UserServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectUser } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class UserRepositoryService implements ApiRepositoryService<
  UserServiceCreateRequest,
  UserServiceUpdateRequest,
  UserServiceListRequest,
  UserServiceCreateResponse
> {
  private api = inject(ConnectUser);

  create(
    data: UserServiceCreateRequest,
  ): Observable<UserServiceCreateResponse> {
    return this.api.create(data).pipe();
  }

  delete(uuid: string): Observable<void> {
    return this.api.delete({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  fetch(uuid: string): Observable<UserServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            UserServiceGetResponseSchema,
            UserServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: UserServiceListRequest,
  ): Observable<ApiPaginated<UserServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(
    data: UserServiceUpdateRequest,
  ): Observable<UserServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            UserServiceUpdateResponseSchema,
            UserServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }
}
